// =============================================================
// Scratch3MQTT — Robot Extension
// Compatible with: Scratch 3 internal loader
// =============================================================

const BlockType    = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');

class Scratch3MQTT {

    // =========================================================
    // CONSTRUCTOR
    // =========================================================

    constructor(runtime) {

        this.runtime = runtime;

        this.client    = null;
        this.connected = false;
        this.mqttLib   = null;

        // =====================================================
        // ROBOT CONFIG
        // =====================================================

        this.robotId = '';

        this.controlTopic   = '';
        this.buzzerTopic    = '';
        this.ultraTopic     = '';
        this.ultraDataTopic = '';
        this.lineTopic      = '';

        // =====================================================
        // SENSOR STATE (received from robot)
        // =====================================================

        this._obstacleDetected    = false;
        this._ultraRawValue       = '';
        this._obstacleThresholdCm = 30;

        // =====================================================
        // ROBOT CLOUD CONFIG
        // =====================================================

        this.defaultHost = 'unicorn.cusc.vn';

        this.defaultPort = 443;

        // =====================================================
        // Connect timeout
        // =====================================================

        this._connectTimeoutHandle = null;
        this._connectTimeoutMs     = 10000;

        // =====================================================
        // Load MQTT library
        // =====================================================

        this.ready = this._loadMQTT();
    }

    // =========================================================
    // SCRATCH BLOCKS DEFINITION
    // =========================================================

    getInfo() {

        return {

            id: 'robotmqtt',

            name: 'Robot',

            color1: '#1E90FF',
            color2: '#0057B8',

            blocks: [

                // -------------------------------------------------
                // ROBOT ID
                // -------------------------------------------------

                {
                    opcode: 'setRobotId',
                    blockType: BlockType.COMMAND,

                    text:
                        'nhập ID robot [ROBOT_ID]',

                    arguments: {

                        ROBOT_ID: {
                            type: ArgumentType.STRING,
                            defaultValue: 'A8K29X'
                        }
                    }
                },

                {
                    opcode: 'getRobotId',
                    blockType: BlockType.REPORTER,

                    text:
                        'ID robot hiện tại'
                },

                '---',

                // -------------------------------------------------
                // ROBOT CLOUD
                // -------------------------------------------------

                {
                    opcode: 'connectRobotCloud',
                    blockType: BlockType.COMMAND,

                    text:
                        'kết nối robot user [USER] pass [PASS]',

                    arguments: {

                        USER: {
                            type: ArgumentType.STRING,
                            defaultValue: 'student01'
                        },

                        PASS: {
                            type: ArgumentType.STRING,
                            defaultValue: '123456'
                        }
                    }
                },

                '---',

                // -------------------------------------------------
                // RAW SERVER CONNECT
                // -------------------------------------------------

                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,

                    text:
                        'kết nối robot server host [HOST] port [PORT] secure [SECURE] user [USER] pass [PASS]',

                    arguments: {

                        HOST: {
                            type: ArgumentType.STRING,
                            defaultValue: 'broker.emqx.io'
                        },

                        PORT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 8084
                        },

                        SECURE: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: true
                        },

                        USER: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        },

                        PASS: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        }
                    }
                },

                {
                    opcode: 'disconnect',
                    blockType: BlockType.COMMAND,

                    text:
                        'ngắt kết nối robot'
                },

                {
                    opcode: 'getConnectionStatus',
                    blockType: BlockType.REPORTER,

                    text:
                        'trạng thái robot'
                },

                {
                    opcode: 'isConnected',
                    blockType: BlockType.BOOLEAN,

                    text:
                        'robot đã kết nối?'
                },

                '---',

                // -------------------------------------------------
                // ROBOT CONTROL
                // -------------------------------------------------

                {
                    opcode: 'forward',
                    blockType: BlockType.COMMAND,
                    text: 'robot tiến'
                },

                {
                    opcode: 'backward',
                    blockType: BlockType.COMMAND,
                    text: 'robot lùi'
                },

                {
                    opcode: 'left',
                    blockType: BlockType.COMMAND,
                    text: 'robot rẽ trái'
                },

                {
                    opcode: 'right',
                    blockType: BlockType.COMMAND,
                    text: 'robot rẽ phải'
                },

                {
                    opcode: 'spinLeft',
                    blockType: BlockType.COMMAND,
                    text: 'robot quay trái'
                },

                {
                    opcode: 'spinRight',
                    blockType: BlockType.COMMAND,
                    text: 'robot quay phải'
                },

                {
                    opcode: 'stop',
                    blockType: BlockType.COMMAND,
                    text: 'dừng robot'
                },

                '---',

                // -------------------------------------------------
                // BUZZER
                // -------------------------------------------------

                {
                    opcode: 'buzzerOn',
                    blockType: BlockType.COMMAND,
                    text: 'bật buzzer'
                },

                {
                    opcode: 'buzzerOff',
                    blockType: BlockType.COMMAND,
                    text: 'tắt buzzer'
                },

                '---',

                // -------------------------------------------------
                // ULTRASONIC SENSOR
                // -------------------------------------------------

                {
                    opcode: 'ultraOn',
                    blockType: BlockType.COMMAND,

                    text:
                        'bật cảm biến khoảng cách'
                },

                {
                    opcode: 'ultraOff',
                    blockType: BlockType.COMMAND,

                    text:
                        'tắt cảm biến khoảng cách'
                },

                {
                    opcode: 'setUltraDistance',
                    blockType: BlockType.COMMAND,

                    text:
                        'gửi khoảng cách [DISTANCE]',

                    arguments: {

                        DISTANCE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 30
                        }
                    }
                },

                '---',

                // -------------------------------------------------
                // LINE SENSOR
                // -------------------------------------------------

                {
                    opcode: 'lineOn',
                    blockType: BlockType.COMMAND,

                    text:
                        'bật cảm biến dò line'
                },

                {
                    opcode: 'lineOff',
                    blockType: BlockType.COMMAND,

                    text:
                        'tắt cảm biến dò line'
                },

                '---',

                // -------------------------------------------------
                // OBSTACLE DETECTION (subscribe / feedback)
                // -------------------------------------------------

                {
                    opcode: 'setObstacleThreshold',
                    blockType: BlockType.COMMAND,

                    text:
                        'đặt ngưỡng phát hiện vật cản [THRESHOLD] cm',

                    arguments: {

                        THRESHOLD: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 30
                        }
                    }
                },

                {
                    opcode: 'getObstacleThreshold',
                    blockType: BlockType.REPORTER,

                    text:
                        'ngưỡng phát hiện vật cản'
                },

                {
                    opcode: 'isObstacleDetected',
                    blockType: BlockType.BOOLEAN,

                    text:
                        'robot phát hiện vật cản?'
                },

                {
                    opcode: 'getUltraRawValue',
                    blockType: BlockType.REPORTER,

                    text:
                        'giá trị cảm biến khoảng cách'
                },

                {
                    opcode: 'whenObstacleDetected',
                    blockType: BlockType.HAT,

                    text:
                        'khi robot phát hiện vật cản'
                },

                {
                    opcode: 'whenObstacleCleared',
                    blockType: BlockType.HAT,

                    text:
                        'khi robot không còn vật cản'
                },

                '---',

                // -------------------------------------------------
                // CUSTOM PUBLISH
                // -------------------------------------------------

                {
                    opcode: 'publishCustom',
                    blockType: BlockType.COMMAND,

                    text:
                        'gửi [MESSAGE] tới topic [TOPIC]',

                    arguments: {

                        MESSAGE: {
                            type: ArgumentType.STRING,
                            defaultValue: 'hello'
                        },

                        TOPIC: {
                            type: ArgumentType.STRING,
                            defaultValue: 'robot/demo/control'
                        }
                    }
                }
            ]
        };
    }

    // =========================================================
    // INTERNAL: UPDATE TOPICS
    // =========================================================

    _updateTopics() {

        this.controlTopic =
            `robot/${this.robotId}/control`;

        this.buzzerTopic =
            `robot/${this.robotId}/buzzer`;

        this.ultraTopic =
            `robot/${this.robotId}/ultra`;

        this.ultraDataTopic =
            `robot/${this.robotId}/ultra/data`;

        this.lineTopic =
            `robot/${this.robotId}/line`;

        console.log(
            '[ROBOT] Control topic:',
            this.controlTopic
        );

        console.log(
            '[ROBOT] Buzzer topic:',
            this.buzzerTopic
        );

        console.log(
            '[ROBOT] Ultra topic:',
            this.ultraTopic
        );

        console.log(
            '[ROBOT] Ultra data topic:',
            this.ultraDataTopic
        );

        console.log(
            '[ROBOT] Line topic:',
            this.lineTopic
        );
    }

    // =========================================================
    // INTERNAL: LOAD MQTT LIBRARY
    // =========================================================

    _loadMQTT() {

        return new Promise((resolve, reject) => {

            if (window.mqtt) {

                this.mqttLib = window.mqtt;

                console.log(
                    '[ROBOT] Library already loaded'
                );

                resolve();

                return;
            }

            const script =
                document.createElement('script');

            script.src =
                'https://unpkg.com/mqtt/dist/mqtt.min.js';

            script.onload = () => {

                this.mqttLib = window.mqtt;

                console.log(
                    '[ROBOT] Library loaded'
                );

                resolve();
            };

            script.onerror = () => {

                console.error(
                    '[ROBOT] Cannot load library'
                );

                reject(
                    new Error('Cannot load MQTT library')
                );
            };

            document.head.appendChild(script);
        });
    }

    // =========================================================
    // INTERNAL: CLEAR TIMEOUT
    // =========================================================

    _clearConnectTimeout() {

        if (this._connectTimeoutHandle) {

            clearTimeout(
                this._connectTimeoutHandle
            );

            this._connectTimeoutHandle = null;
        }
    }

    // =========================================================
    // INTERNAL: PUBLISH HELPER
    // =========================================================

    _publish(topic, msg) {

        if (!this.client || !this.connected) {

            console.warn(
                '[ROBOT] Not connected'
            );

            return;
        }

        this.client.publish(

            topic,

            msg,

            { qos: 1 },

            err => {

                if (err) {

                    console.error(
                        '[ROBOT] Publish error:',
                        err
                    );

                    return;
                }

                console.log(
                    '[ROBOT] Published:',
                    topic,
                    msg
                );
            }
        );
    }

    // =========================================================
    // BLOCK: SET ROBOT ID
    // =========================================================

    setRobotId(args) {

        const inputId = String(
            args.ROBOT_ID || ''
        )

        .trim()

        .replace(/[^a-zA-Z0-9_-]/g, '')

        .substring(0, 32);

        if (!inputId) {

            console.warn(
                '[ROBOT] Invalid Robot ID'
            );

            return;
        }

        this.robotId = inputId;

        this._updateTopics();

        console.log(
            '[ROBOT] Robot ID set:',
            this.robotId
        );
    }

    getRobotId() {

        return this.robotId;
    }

    // =========================================================
    // BLOCK: CONNECT ROBOT CLOUD
    // =========================================================

    connectRobotCloud(args) {

        return this.connect({

            HOST: this.defaultHost,

            PORT: this.defaultPort,

            USER: args.USER,

            PASS: args.PASS,

            SECURE: true
        });
    }

    // =========================================================
    // BLOCK: CONNECT
    // =========================================================

    connect(args) {

        return new Promise(async resolve => {

            try {

                await this.ready;

                if (!this.mqttLib) {

                    console.error(
                        '[ROBOT] Library not ready'
                    );

                    return resolve();
                }

                // ------------------------------------------------
                // Destroy old client
                // ------------------------------------------------

                if (this.client) {

                    this.client.removeAllListeners();

                    this.client.end(true);

                    this.client    = null;
                    this.connected = false;
                }

                // ------------------------------------------------
                // ws / wss
                // ------------------------------------------------

                const protocol =

                    args.SECURE === false

                        ? 'ws'

                        : 'wss';

                const url =

                    `${protocol}://${args.HOST}:${args.PORT}/mqtt`;

                console.log(
                    '[ROBOT] Connecting:',
                    url
                );

                // ------------------------------------------------
                // OPTIONS
                // ------------------------------------------------

                const options = {

                    username:
                        args.USER || undefined,

                    password:
                        args.PASS || undefined,

                    reconnectPeriod: 3000,

                    connectTimeout:
                        this._connectTimeoutMs,

                    keepalive: 20,

                    clean: true,

                    resubscribe: false
                };

                this.client =
                    this.mqttLib.connect(
                        url,
                        options
                    );

                // ------------------------------------------------
                // TIMEOUT
                // ------------------------------------------------

                this._connectTimeoutHandle =

                    setTimeout(() => {

                        if (!this.connected) {

                            console.error(
                                '[ROBOT] Connect timeout'
                            );

                            resolve();
                        }

                    },

                    this._connectTimeoutMs
                );

                // ------------------------------------------------
                // CONNECT
                // ------------------------------------------------

                this.client.on('connect', () => {

                    this._clearConnectTimeout();

                    this.connected = true;

                    console.log(
                        '[ROBOT] Connected'
                    );

                    // ----------------------------------------
                    // Subscribe to sensor feedback topics
                    // ----------------------------------------

                    this._subscribeToSensorTopics();

                    resolve();
                });

                // ------------------------------------------------
                // MESSAGE (incoming from robot)
                // ------------------------------------------------

                this.client.on('message', (topic, payload) => {

                    const msg = payload.toString().trim();

                    this._handleIncomingMessage(topic, msg);
                });

                // ------------------------------------------------
                // RECONNECT
                // ------------------------------------------------

                this.client.on('reconnect', () => {

                    this.connected = false;

                    console.log(
                        '[ROBOT] Reconnecting...'
                    );
                });

                // ------------------------------------------------
                // OFFLINE
                // ------------------------------------------------

                this.client.on('offline', () => {

                    this.connected = false;

                    console.warn(
                        '[ROBOT] Offline'
                    );
                });

                // ------------------------------------------------
                // CLOSE
                // ------------------------------------------------

                this.client.on('close', () => {

                    this.connected = false;

                    console.warn(
                        '[ROBOT] Connection closed'
                    );
                });

                // ------------------------------------------------
                // ERROR
                // ------------------------------------------------

                this.client.on('error', err => {

                    this._clearConnectTimeout();

                    this.connected = false;

                    console.error(
                        '[ROBOT] Error:',
                        err.message
                    );

                    resolve();
                });

            } catch (err) {

                this._clearConnectTimeout();

                console.error(
                    '[ROBOT] Connect failed:',
                    err
                );

                resolve();
            }
        });
    }

    // =========================================================
    // BLOCK: DISCONNECT
    // =========================================================

    disconnect() {

        this._clearConnectTimeout();

        if (!this.client) return;

        this.client.removeAllListeners();

        this.client.end(true);

        this.client    = null;
        this.connected = false;

        console.log(
            '[ROBOT] Disconnected manually'
        );
    }

    // =========================================================
    // BLOCK: GET CONNECTION STATUS
    // =========================================================

    getConnectionStatus() {

        if (!this.client)
            return 'chưa kết nối';

        if (this.connected)
            return 'đã kết nối';

        return 'đang kết nối lại...';
    }

    // =========================================================
    // BLOCK: IS CONNECTED
    // =========================================================

    isConnected() {

        return this.connected;
    }

    // =========================================================
    // BLOCK: CUSTOM PUBLISH
    // =========================================================

    publishCustom(args) {

        this._publish(
            args.TOPIC,
            args.MESSAGE
        );
    }

    // =========================================================
    // ROBOT CONTROL
    // =========================================================

    forward() {

        if (!this.robotId) return;

        this._publish(
            this.controlTopic,
            'F'
        );
    }

    backward() {

        if (!this.robotId) return;

        this._publish(
            this.controlTopic,
            'B'
        );
    }

    left() {

        if (!this.robotId) return;

        this._publish(
            this.controlTopic,
            'L'
        );
    }

    right() {

        if (!this.robotId) return;

        this._publish(
            this.controlTopic,
            'R'
        );
    }

    spinLeft() {

        if (!this.robotId) return;

        this._publish(
            this.controlTopic,
            'SL'
        );
    }

    spinRight() {

        if (!this.robotId) return;

        this._publish(
            this.controlTopic,
            'SR'
        );
    }

    stop() {

        if (!this.robotId) return;

        this._publish(
            this.controlTopic,
            'S'
        );
    }

    // =========================================================
    // BUZZER
    // =========================================================

    buzzerOn() {

        if (!this.robotId) return;

        this._publish(
            this.buzzerTopic,
            'ON'
        );
    }

    buzzerOff() {

        if (!this.robotId) return;

        this._publish(
            this.buzzerTopic,
            'OFF'
        );
    }

    // =========================================================
    // ULTRASONIC
    // =========================================================

    ultraOn() {

        if (!this.robotId) return;

        this._publish(
            this.ultraTopic,
            'ON'
        );
    }

    ultraOff() {

        if (!this.robotId) return;

        this._publish(
            this.ultraTopic,
            'OFF'
        );
    }

    setUltraDistance(args) {

        if (!this.robotId) return;

        let distance =
            Number(args.DISTANCE);

        if (isNaN(distance)) {

            console.warn(
                '[ROBOT] Invalid distance'
            );

            return;
        }

        distance =
            Math.max(30, distance);

        distance =
            Math.min(60, distance);

        this._publish(
            this.ultraTopic,
            String(distance)
        );
    }

    // =========================================================
    // LINE SENSOR
    // =========================================================

    lineOn() {

        if (!this.robotId) return;

        this._publish(
            this.lineTopic,
            'ON'
        );
    }

    lineOff() {

        if (!this.robotId) return;

        this._publish(
            this.lineTopic,
            'OFF'
        );
    }

    // =========================================================
    // BLOCK: SET OBSTACLE THRESHOLD
    // =========================================================

    setObstacleThreshold(args) {

        const value = Number(args.THRESHOLD);

        if (isNaN(value) || value <= 0) {

            console.warn(
                '[ROBOT] Invalid obstacle threshold'
            );

            return;
        }

        this._obstacleThresholdCm = value;

        console.log(
            '[ROBOT] Obstacle threshold set:',
            this._obstacleThresholdCm,
            'cm'
        );
    }

    // =========================================================
    // BLOCK: GET OBSTACLE THRESHOLD
    // =========================================================

    getObstacleThreshold() {

        return this._obstacleThresholdCm;
    }

    // =========================================================
    // OBSTACLE DETECTION — BOOLEAN BLOCK
    // =========================================================

    isObstacleDetected() {

        return this._obstacleDetected;
    }

    // =========================================================
    // ULTRASONIC RAW VALUE — REPORTER BLOCK
    // =========================================================

    getUltraRawValue() {

        return this._ultraRawValue;
    }

    // =========================================================
    // HAT: WHEN OBSTACLE DETECTED
    // =========================================================

    whenObstacleDetected() {

        return this._obstacleDetected;
    }

    // =========================================================
    // HAT: WHEN OBSTACLE CLEARED
    // =========================================================

    whenObstacleCleared() {

        return !this._obstacleDetected;
    }

    // =========================================================
    // INTERNAL: SUBSCRIBE TO SENSOR FEEDBACK TOPICS
    // =========================================================

    _subscribeToSensorTopics() {

        if (!this.client || !this.robotId) return;

        this.client.subscribe(
            this.ultraDataTopic,
            { qos: 1 },
            err => {

                if (err) {

                    console.error(
                        '[ROBOT] Subscribe error (ultra/data):',
                        err
                    );

                    return;
                }

                console.log(
                    '[ROBOT] Subscribed:',
                    this.ultraDataTopic
                );
            }
        );
    }

    // =========================================================
    // INTERNAL: HANDLE INCOMING MESSAGE FROM ROBOT
    // =========================================================

    _handleIncomingMessage(topic, msg) {

        console.log(
            '[ROBOT] Message received:',
            topic,
            msg
        );

        // ------------------------------------------------
        // Ultra data topic → obstacle detection
        // ------------------------------------------------

        if (topic === this.ultraDataTopic) {

            this._ultraRawValue = msg;

            const prevDetected = this._obstacleDetected;

            // Robot sends "DETECTED" when obstacle found,
            // "CLEAR" when path is free.
            // Also accepts numeric distance (cm): treat
            // values <= threshold as obstacle detected.

            if (msg === 'DETECTED') {

                this._obstacleDetected = true;

            } else if (msg === 'CLEAR') {

                this._obstacleDetected = false;

            } else {

                // Numeric fallback: distance in cm
                const dist = Number(msg);

                if (!isNaN(dist)) {

                    // Use the configured threshold (default 30 cm)
                    this._obstacleDetected = dist <= this._obstacleThresholdCm;
                }
            }

            // Trigger Scratch runtime hat blocks when state changes

            if (this._obstacleDetected !== prevDetected) {

                this.runtime.startHats(
                    this._obstacleDetected
                        ? 'robotmqtt_whenObstacleDetected'
                        : 'robotmqtt_whenObstacleCleared'
                );
            }
        }
    }
}

module.exports = Scratch3MQTT;